module.exports = __webpack_public_path__ + "img/chevy-Used.81622dac.png";